import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SocialFollowRender from './SocialFollowRender';
import { PORTRAIT, LANDSCAPE } from './sf.config';

const SocialFollow = ({ orientation, ...otherProps }) => {
  const { socialNetworks = {} } = otherProps;
  const socialNetKeys = Object.keys(socialNetworks);
  const isPortrait = orientation === PORTRAIT;
  if (!socialNetKeys.length) return null;

  const divClassName = classnames({
    'social social--follow social--vertical': isPortrait,
    'social social--follow': !isPortrait
  });

  return (
    <div className={divClassName}>
      <SocialFollowRender isPortrait={isPortrait} socialNetKeys={socialNetKeys} {...otherProps} />
    </div>
  );
};

SocialFollow.propTypes = {
  orientation: PropTypes.string
};

SocialFollow.defaultProps = {
  orientation: LANDSCAPE
};

export default SocialFollow;
